export default __webpack_public_path__ + "static/media/14_HuangLiang.f648ad96.png";